import propTypes from 'prop-types';
import logoPorter from '../../../../assets/images/logo.png';
import logoPorterBlack from '../../../../assets/images/logo-black.png';
import * as S from './styles';

const CalendarLayout = ({ children, wide, compact }) => (
  <S.PageWrapper>
    <S.Content $wide={wide} $compact={compact}>
      <S.HeaderContainer>
        <S.LogoImage src={logoPorter} alt="Porter" $compact={compact} />
      </S.HeaderContainer>

      {children}
    </S.Content>

    <S.Footer $compact={compact}>
      <S.PoweredByText>powered by</S.PoweredByText>
      <S.FooterLogo src={logoPorterBlack} alt="Porter" />
    </S.Footer>
  </S.PageWrapper>
);

CalendarLayout.propTypes = {
  children: propTypes.node.isRequired,
  wide: propTypes.bool,
  compact: propTypes.bool,
};

CalendarLayout.defaultProps = {
  wide: false,
  compact: false,
};

export default CalendarLayout;
